<!--
  Program: Bread crumb
  Author: SDL
  Brief: Components that visually show where the current user is
-->
<template>
  <div class='content_heading'>
    <h3>{{ title }}</h3>
    <a @click='modifyUserQuickMenu' :class='setBookmark' :title="$t('sdl.myMenu.label.favorite.title')"/><!-- 선택시 class="bookmark on" -->
    <!-- <a href="#" class="info" @click="showHelpPopup"/> -->

    <button class="st_label ico_info_circle" @click='resourceTypesPopup()' v-if="isResourceTypes"
      style="top: 8px;padding: 12px 6px 12px 25px; font-size:14px; margin-left:15px;">Resource Types</button>

    <!-- web client 메뉴 경우에만 노출 -->
    <div class='button' v-if='titleButtonShow'>
      <button class='btn btn-sm btn-secondary'
              @click='deRegisterMachinePopup()'
              type='button'>
        {{ 'De-register Machine' }}
      </button>
      <button class='btn btn-sm btn-secondary'
              type='button'
              @click='clientConnect()'
              v-if='!webClientSocketConnectionState'>
        {{ 'Try Client Connection' }}
      </button>
    </div>
    <!-- web client 메뉴 경우에만 노출 -->
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='item' v-if='home'>
          <router-link :to="{ name: 'mainIndexPage' }">{{ homeText }}</router-link>
        </li>
        <li
          class='item'
          :class='{ active: index === list.length - 1 }'
          v-for='(item, index) in list'
          :key='item.menuId'
        >
          <a>{{ getLabel(item) }}</a>
          <!-- <a :href="'' !== item.menuUrl && item.menuUrl ? item.menuUrl : 'javascript:'">{{item.localeLabel}}</a> -->
          <!-- <router-link v-if="index === list.length - 1" :to="item.menuUrl" tag="span">{{item.localeLabel}}</router-link>
          <a :href="'' !== item.menuUrl && item.menuUrl ? item.menuUrl : 'javascript:'" v-else>{{item.localeLabel}}</a> -->
        </li>

        <!-- <li class="breadcrumb-item"><a href="#">Menu1</a></li>
        <li class="breadcrumb-item"><a href="#">Submenu1</a></li>
        <li class="breadcrumb-item active" aria-current="page">Submenu1-1</li> -->
      </ol>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import axios from 'axios';
import { SDLUtil, RequestUtil } from '@/utils';
import SDLLocale from '@/mixin/SDLLocale';
import HelpPopup from '@/components/view/admin/etc/help/popup/HelpPopup';
import { getWebClientSocket } from '@/service/webClientService';
import DeRegisterMachinePopup from '@/components/view/web-client/popup/DeRegisterMachinePopup.vue';
import ResourceTypesPopup from '@/components/view/rem/permissionManager/resource/popup/ResourceTypesPopup.vue';

export default {
  name: 'Breadcrumb',
  mixins: [SDLLocale],
  props: {
    home: {
      required: false,
      type: Boolean,
      default: false,
    },
    homeText: {
      required: false,
      type: String,
      default: 'Home',
    },
    isResourceTypes: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '',
      list: [],
      menuId: '',
    };
  },
  computed: {
    ...mapGetters({
      menus: 'getMenus',
      userMenus: 'getUserMenusBreadCrumb',
    }),
    menu() {
      if (this.$route.meta.menuId) return _.find(this.menus, ['menuId', this.$route.meta.menuId]);
      return _.find(this.menus, ['label', 'Access Key Summary']);
    },
    pageId() {
      return this.$route.meta.pageId;
    },
    userMenuYN() {
      const menuIdList = _.map(this.userMenus, 'menuId');
      return menuIdList.includes(this.menuId);
    },
    setBookmark() {
      if (this.userMenuYN) {
        return 'bookmark on';
      }
      return 'bookmark';
    },
    titleButtonShow() {
      const menuIdList = _.map(SDLUtil.getCommCodeList({ commCodeTypeId: 'ADDITION_FEAT_MENUID' }), 'code');
      const { menuId } = this.menu;
      return _.includes(menuIdList, menuId);
    },
    webClientSocketConnectionState() {
      return this.$store.getters.getWebClientSocketConnectionState;
    },
  },
  watch: {
    menus() {
      this.setTitle();
      this.setBreadcrumb();
    },
    locale() {
      this.setTitle();
    },
    $route() {
      this.setTitle();
      this.setBreadcrumb();
    },
    menu: {
      handler() {
        this.menuId = this.menu.menuId;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    resourceTypesPopup() {
      SDLUtil.show(ResourceTypesPopup, {}, { sizeClass: 'big'});
    },
    getParentMenu(parentId) {
      return this.menus.find(item => item.menuId === parentId);
    },
    setTitle() {
      if (this.menu) {
        this.title = this.getLabel(this.menu);
        // this.title = this.menu.localeLabel;
      }
    },
    setBreadcrumb() {
      if (this.menu) {
        this.list = [this.menu];
        for (let i = this.menu.menuLevel - 1; i > 0; i -= 1) {
          const parentMenu = this.getParentMenu(this.list[0].parentId);
          if (parentMenu) {
            this.list = [parentMenu, ...this.list];
          }
        }
      }
    },
    getUserQuickMenus() {
      const quickMenus = this.menus
        .filter(menu => {
          // 외부 링크 사용
          if (menu.externalUrlUsed) {
            return true;
          }
          // default Page 가 있는 메뉴
          return menu.pages.length > 0 && _.find(menu.pages, ['defaulted', true]);
        })
        .map(menu => {
          const defaultPage = _.find(menu.pages, ['defaulted', true]);
          return {
            ...menu,
            ...defaultPage,
            selected: false,
          };
        });

      const param = {
        menus: this.menus,
        quickMenus,
      };
      axios
        .get(`${SDLUtil.API_URL}/auth/quick-menus`)
        .then(response => {
          const userMenus = [];
          response.data.forEach(menuId => {
            const menu = _.find(param.quickMenus, ['menuId', menuId]);
            if (menu) {
              menu.selected = true;
              userMenus.push(menu);
            }
          });
          this.$store.commit('SET_USER_MENUS_BREAD_CRUMB', userMenus);
        });

      // loading bar 보이지 않는 이슈로 인하여 RequestUtil 대신 axios 그대로 사용
      // this.$store.dispatch('GET_USER_MENUS_BREAD_CRUMB', param);
    },
    confirmModifyUserQuickMenu() {
      let msg = '';
      if (this.userMenuYN) {
        msg = 'sdl.myMenu.message.delete';
      } else {
        msg = 'sdl.myMenu.message.save';
      }

      SDLUtil.confirm({
        msg,
        okLabel: 'sdl.common.label.confirm',
        cancelLabel: 'sdl.common.label.cancel',
        onOkEvt: () => this.modifyUserQuickMenu(),
        onCancelEvt: () => console.log('cancel'),
      });
    },
    modifyUserQuickMenu() {
      SDLUtil.showLoadingBar(true);
      let menus = _.map(this.userMenus, 'menuId');
      if (this.userMenuYN) {
        menus = _.remove(menus, menu => menu !== this.menuId);
      } else if (!this.userMenuYN) menus.push(this.menuId);
      this.$store.dispatch('MODIFY_USER_MENU_BREAD_CRUMB', menus).then(() => {
        this.getUserQuickMenus();
        SDLUtil.showLoadingBar(false);
      });
    },
    showHelpPopup() {
      SDLUtil.show(
        HelpPopup,
        {
          menu: {
            ...this.menu,
            parent: this.list,
          },
          // rtnFunc: result => {
          // },
        },
        {
          // 가로사이즈 : big, large, medium, small, mini
          // 세로사이즈고정 : h_fix
          sizeClass: 'medium',
          // width: '900px',
          // height: 'auto',
        },
      );
    },
    async clientConnect() {
      await getWebClientSocket(this);
    },
    deRegisterMachinePopup() {
      SDLUtil.show(
        DeRegisterMachinePopup,
        {
          // 팝업에 넘기는 파라미터
          // props: propsSample,
          // rtnFunc: result => {
          //   console.log(result);
          // },
        },
        {
          // 가로사이즈 : big, large, medium, small, mini
          // 세로사이즈고정 : h_fix
          sizeClass: 'small',
        },
      );
    },
  },
  created() {
    this.setTitle();
    this.setBreadcrumb();
    this.getUserQuickMenus();
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/common/control/breadcrumb/Breadcrumb.vue